import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Outlet, useParams } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { InboxesRoutes } from 'pages/settings/pages/inboxes'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'

export const InboxPageCallingV1Redirect = observer(() => {
  const { id } = useParams()
  const [loading, setLoading] = useState<boolean | null>(true)
  const { featureFlagsStore } = useEntitiesContext()
  useEffect(() => {
    featureFlagsStore.fetchFeatureFlags().then(() => {
      if (featureFlagsStore.settings_inboxes_manage_inbox_calling_v2) {
        uiStore.changeRoute({
          path: `/${InboxesPath.root}/${id}/${InboxesRoutes.settings}/${InboxesRoutes.calling}`,
        })
      }
      setLoading(false)
    })
  }, [])
  if (loading) return <SpinnerLoader ariaLabel={'InboxPageCallingV1Redirect'} />

  return <Outlet />
})
